import script from "./FloatingContactButtons.vue?vue&type=script&setup=true&lang=ts"
export * from "./FloatingContactButtons.vue?vue&type=script&setup=true&lang=ts"

import "./FloatingContactButtons.vue?vue&type=style&index=0&id=1bb286d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bb286d2"]])

export default __exports__